import { createReducer, AnyAction } from '@reduxjs/toolkit';
import { WarnningBannerIsVisible as WarnningBannerStoreState } from '../types/warnningBanner.types';
import { closeWarningBanner } from '../actions/app.actions';

export const initialState: WarnningBannerStoreState = true;

interface WarnningBanner {
	[x: string]: (
		state: WarnningBannerStoreState,
		action: AnyAction,
	) => WarnningBannerStoreState | undefined;
}

const reducer: WarnningBanner = {
	[closeWarningBanner.toString()]: (state, action) => false,
};

export default createReducer(initialState, reducer);
